import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Config } from 'src/app/config/config';


@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimePickerComponent implements OnInit {
  @Input() options: DatePickerOptions;
  @Input() inputModel;
  @Output() inputModelChange = new EventEmitter<string>();
  public currentDate: any = new Date();

  constructor(
  ) { }

  ngOnInit() {
    this.checkValidDate();
  }
  checkValidDate() {
    if (!this.inputModel) {
      const fromDate = new Date();
      // fromDate.setDate(fromDate.getDate() - 1);
      fromDate.setDate(fromDate.getDate());
      fromDate.setHours(0, 0, 0, 0);
      const toDate = new Date();
      // toDate.setDate(toDate.getDate() - 1);
      toDate.setDate(toDate.getDate());
      // toDate.setHours(23, 59, 0, 0);
      if (this.options.selectMode === 'range') {
        this.inputModel = [fromDate, toDate];
      } else {
        this.inputModel = new Date();
      }
      setTimeout(() => {
        this.inputModelChange.emit(this.inputModel);
      }, 300);
    }
    this.checkMaxDate();
  }
  setToDateAsCurrentTime() {
    this.inputModel[1] = new Date();
  }

  /**
   * To Disable Max Date to current Date in some cases
   */
  checkMaxDate() {
    try {
      if (this.options.noMaxDate) {
        this.currentDate = null;
      }
    } catch (error) {
      Config.logger(error);
    }
  }

}


export class DatePickerOptions {
  selectMode: 'range' | 'single' | 'singleFullDay';
  required?: boolean;
  fromDateLabel?: string;
  toDateLabel?: string;
  name?: string;
  pickerType: 'both' | 'calendar' | 'timer';
  noMaxDate?: boolean;
  readonly?: boolean;
}
